import { DateTime } from "luxon";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import Badge from "react-bootstrap/Badge";
import Card from "react-bootstrap/Card";
import {
  getFieldDate,
  getFieldName,
  getFieldText,
} from "../../scripts/helperScripts";
import getCompliancy from "../services/compliancyService";
import CompliancyModal from "./CompliancyModal";

function ProgramMiniCard({ clientProgram, careplan, history, headerTooltip }) {
  const latestActiveCarePlan = useMemo(() => {
    return careplan
      ?.filter?.((a) => a.ccx_esigndatetime)
      .sort?.((a, b) => {
        const aDate = DateTime.fromISO(getFieldText(a.ccx_effectivedate));
        const bDate = DateTime.fromISO(getFieldText(b.ccx_effectivedate));
        return aDate < bDate ? 1 : aDate > bDate ? -1 : 0;
      })[0];
  }, [careplan]);
  const [compliancy, setCompliancy] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const config = useMemo(() => {
    return clientProgram["unit.sor_compliancy"]
      ? JSON.parse(clientProgram["unit.sor_compliancy"])
      : {};
  }, [clientProgram]);
  const user = JSON.parse(localStorage.getItem("safyInfo")).user;

  useEffect(() => {
    if (clientProgram && history && config?.compliancy) {
      const compliant = getCompliancy(
        config.compliancy,
        clientProgram,
        history
      );
      setCompliancy(compliant);
    }
  }, [clientProgram, history, config]);

  const CarePlan = () => {
    if (clientProgram.ccx_dischargedate === undefined) {
      if (latestActiveCarePlan) {
        return (
          <h3 className="float-end">
            {latestActiveCarePlan.ccx_nextreviewdate &&
              DateDiff(getFieldDate(latestActiveCarePlan.ccx_nextreviewdate))}
          </h3>
        );
      }
    }
  };

  const DateDiff = (from) => {
    const diff =
      Math.round(new Date(from).getTime() - new Date().getTime()) /
      (1000 * 3600 * 24);
    if (diff < 15) {
      return (
        <Badge
          className="bg-danger float-end"
          title={diff.toFixed(0) + " days until careplan due"}
        >
          <span>{diff.toFixed(0)}</span>
        </Badge>
      );
    }
    if (diff > 14 && diff < 31) {
      return (
        <Badge
          className="bg-warning float-end"
          title={diff.toFixed(0) + " days until careplan due"}
        >
          <span>{diff.toFixed(0)}</span>
        </Badge>
      );
    }
    return (
      <Badge
        className="bg-secondary float-end"
        title={diff.toFixed(0) + " days until careplan due"}
      >
        <span>{diff.toFixed(0)}</span>
      </Badge>
    );
  };

  const openClientProgram = (id) => {
    const url =
      process.env.REACT_APP_ORG +
      "/main.aspx?etc=10084&extraqs=id=" +
      id +
      "&pagetype=entityrecord";
    window.open(url);
  };

  return (
    <>
      {isOpen ? (
        <CompliancyModal
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          clientProgram={clientProgram}
          compliancy={compliancy}
          user={user}
        />
      ) : null}
      <Card
        key={clientProgram.ccx_client_programid}
        bg="light"
        text="dark"
        className={
          clientProgram.ccx_dischargedate || clientProgram["care.ccx_expdate"]
            ? "mb-1 w-100 safy-border-4 border-danger"
            : "mb-1 w-100"
        }
      >
        <Card.Header
          style={{ padding: "0px 0px 0px 10px" }}
          className="row text-safy-info m-0 p-0"
        >
          <div
            className="col"
            onClick={() =>
              openClientProgram(clientProgram.ccx_client_programid)
            }
            role="button"
          >
            {getFieldName(clientProgram.ccx_programunit)}
          </div>
          {headerTooltip}
          {config?.compliancy && (
            <i
              className={`col-auto float-end me-1 mt-1 ${
                Object.values(compliancy).some((c) => {
                  return c.history?.some((h) => {
                    return (
                      (h.compliant === "Not Done" &&
                        moment().isAfter(
                          moment(h.dueDate).subtract(h.window, "days")
                        )) ||
                      h.compliant === "Past Due"
                    );
                  });
                })
                  ? "fas fa-triangle-exclamation text-danger"
                  : "fas fa-circle-check text-success"
              }`}
              onClick={() => setIsOpen(true)}
              role="button"
            ></i>
          )}
        </Card.Header>
        <Card.Body style={{ padding: "10px" }}>
          <div className="row">
            <div className="col">
              <div>Admitted </div>
              <div>
                {moment(getFieldText(clientProgram.ccx_admitdate)).format("L")}
              </div>
              {clientProgram.ccx_dischargedate && (
                <div style={{ color: "red" }}>
                  Discharged on{" "}
                  {moment(getFieldText(clientProgram.ccx_dischargedate)).format(
                    "L"
                  )}
                  {clientProgram.sor_dischargereasontext ? (
                    <>
                      <br />
                      Reason: {clientProgram.sor_dischargereasontext}
                    </>
                  ) : null}
                </div>
              )}
              {clientProgram["care.ccx_expdate"] && (
                <div style={{ color: "red" }}>
                  No Longer on Care Team as of{" "}
                  {getFieldDate(clientProgram["care.ccx_expdate"])}
                </div>
              )}
            </div>
            <div className="col-auto">{CarePlan()}</div>
          </div>
        </Card.Body>
      </Card>
    </>
  );
}

export default ProgramMiniCard;
